<footer class="brand-footer bg-lw-green p-10 text-lg text-lw-tan">
  <div class="brand-footer__container mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-5 desktop:flex-row">
    <img class="max-w-[130px]" src="https://cdn.lonewolfranchpets.com/images/LWR-Logo-White.png" alt="">
    <div class="flex gap-8 font-semibold">
      @for (link of links; track link.label) {
        <a href="{{ link.page }}" target="_blank" (click)="$event.preventDefault(); openLink(link.page)">{{ link.label }}</a>
      }
    </div>
    <div class="space-y-2.5 text-center desktop:text-right">
      <div [innerHTML]="phone"></div>
      <div [innerHTML]="address"></div>
      <div>©{{ year }} {{ brand }}</div>
    </div>
  </div>
</footer>
